'use client';

import React, { useState } from 'react';
import { useGetEngageStrategyDetailsQuery } from 'src/api/redux';
import {
  StrategyProfileHeader,
  StrategyProfileMap,
  StrategyProfileList,
  EngageStrategyMetricsHeader,
} from '../../components';
import StrategyProfileLayout from '../StrategyProfileLayout';
import { STRATEGY_COLORS } from '../..';

type View = 'map' | 'list';

interface TreatingVolumeViewProps {
  engageStrategyId: string;
}

const TreatingVolumeView: React.FC<TreatingVolumeViewProps> = ({
  engageStrategyId,
}) => {
  const [view, setView] = useState<View>('map');

  const { data: engageStrategyDetails } = useGetEngageStrategyDetailsQuery(
    engageStrategyId,
    { skip: !engageStrategyId }
  );

  return (
    <StrategyProfileLayout>
      <StrategyProfileHeader
        view={view}
        setView={setView}
        description={engageStrategyDetails?.description || ''}
        title={engageStrategyDetails?.label || ''}
      >
        <EngageStrategyMetricsHeader
          engageStrategyId={engageStrategyId}
          color={STRATEGY_COLORS['TREATING_VOLUME']}
        />
      </StrategyProfileHeader>

      {view === 'map' ? (
        <StrategyProfileMap engageStrategyId={engageStrategyId} />
      ) : (
        <StrategyProfileList engageStrategyId={engageStrategyId} />
      )}
    </StrategyProfileLayout>
  );
};

export default TreatingVolumeView;
